import { apiYClickAdministration } from "./api";

// CHATBOT
export const postStartChatbotRound = (body) =>
  apiYClickAdministration.post("/v2/chats/new", body);
export const postChatbotQuestion = (body, id) =>
  apiYClickAdministration.post(`/v2/chats/${id}/rounds/new`, body);

// TRAZABILITY REPORT
export const getFirstDateRequest = () => 
  apiYClickAdministration.get("/api/v1/userRequests/date");
export const postUserTrazabilityReport = (body) => {
  return apiYClickAdministration.post("/api/v1/userRequests/excelTraceabilityDownload",body,
  {
    headers: {
      Accept: '*/*'
    },
    responseType: 'blob'
  }
  )
};

// USER PROFILE
export const getFirstLogin = () => apiYClickAdministration.get('/api/v1/userRequests/firstLogin');
export const getInfoProfile = () => apiYClickAdministration.get('/api/v1/userRequests/profile');